{
    "Routes.error.pageNotFound": "FR: Page Not Found.",
    "Routes.error.home": "FR: Home.",
    "Routes.error.accessDenied": "FR: Access Denied.",
    "Routes.error.unknownError": "FR: Unknown Error!"
}
